module.exports = __webpack_public_path__ + "static/media/Bart Brink.bdf26d97.jpg";